import Axios, { AxiosInstance } from 'axios';
import { env } from './env';

export class Request {
    private axios: AxiosInstance;

    constructor() {
        this.axios = Axios.create({ baseURL: env.OPEN_PLATFORM_ORIGIN });
    }

    async createKoutuRecord(options: { url: string; token: string }) {
        const url = options.url;
        const imgData = await this.axios
            .get(url, { responseType: 'arraybuffer' })
            .then((res) => res.data);
        const { width, height } = await new Promise<{ width: number; height: number }>((resolve) => {
            const img = document.createElement('img');
            img.src = url;
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
        });

        const res = await this.axios.post<{ work_id: string }>(
            '/sdk/api/koutu-records',
            { url, size: imgData.byteLength, width, height },
            {
                headers: {
                    authorization: `Bearer ${options.token}`,
                },
            },
        );
        return res.data.work_id;
    }

    async koutu(options: {
        url: string;
        appId: string;
        abilityCode: string;
        workId: string;
        useCert: string;
        token: string;
    }) {
        const res = await this.axios.post<{ result: string }>(
            '/sdk/api/koutus',
            {
                app_id: options.appId,
                url: options.url,
                ability_code: options.abilityCode,
                work_id: options.workId,
                use_cert: options.useCert,
            },
            {
                headers: {
                    authorization: `Bearer ${options.token}`,
                },
            },
        );
        return res.data.result;
    }

    async createAuth(code: string) {
        const res = await this.axios.post<{ access_token: string }>('/sdk/api/auths', { code });
        return res.data.access_token;
    }
}
